import * as React from "react";
import { CommonInsightsReportsView } from "~/components/ContextualHelpLayout/PageHelpRegistry/Registrations/CommonComponents/CommonInsightsReportsView";
import pageIds from "~/pageIds";
import type { CategorizedPageHelpRegistration } from "../../../Registry/pageHelpRegistry";
export const InsightsUpsellRegistration: CategorizedPageHelpRegistration = {
    page: pageIds.insights.reports,
    renderOverview: (props) => <CommonInsightsReportsView />,
    renderTopics: (props) => null,
};
